import { AuthTokenResponse } from '../types';
import FetchInstance from './FetchInstance';

export const loginToApi = async (name: string, password: string): Promise<AuthTokenResponse> => {
    const res = await FetchInstance.fetch('/auth-token', {
        method: 'POST',
        body: JSON.stringify({ name, password }),
    });
    const data = res.json();
    return data;
};
